import { useQuery } from 'react-query';
import { trackPromise } from 'react-promise-tracker';
import { getAllSystems, getSystem } from '../index';
export const useGetAllSystems = (additionlInfo) => useQuery(['GetAllSystems', additionlInfo], () => trackPromise(getAllSystems(additionlInfo)), {
    cacheTime: 0
});
export const useGetSystemByGuid = (additionlInfo) => useQuery(['GetSystemByGuid', additionlInfo], () => trackPromise(getSystem(additionlInfo)), {
    cacheTime: 0
});
